import { createApp } from 'vue';
import PefToAvifConverter from '../Components/PefToAvifConverter.vue';

const root = document.getElementById('pef-to-avif-converter');
if (root) {
  createApp(PefToAvifConverter).mount('#pef-to-avif-converter');
}
